import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import _regenerator from "@babel/runtime/helpers/esm/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.error.to-string.js";
import pesquisa from '@/services/pesquisa';
var state = {
  perguntas: null,
  pesquisa: null,
  respostas: null
};
var mutations = {};
var actions = {
  getPesquisa: function getPesquisa(_ref, identificador) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var commit, dispatch, _yield$pesquisa$get, data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref.commit, dispatch = _ref.dispatch;
            _context.p = 1;
            _context.n = 2;
            return pesquisa.get(identificador);
          case 2:
            _yield$pesquisa$get = _context.v;
            data = _yield$pesquisa$get.data;
            commit('auth/empresa', data.empresa, {
              root: true
            });
            commit('auth/cliente', data.cliente, {
              root: true
            });
            dispatch('auth/atualizarTema', data.empresa.tema, {
              root: true
            });
            return _context.a(2, data.pesquisa);
          case 3:
            _context.p = 3;
            _t = _context.v;
            throw new Error(_t);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }))();
  },
  enviaRespostas: function enviaRespostas(_ref2, payload) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var identificador, _yield$pesquisa$envia, data, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _objectDestructuringEmpty(_ref2);
            identificador = payload.identificador;
            delete payload.identificador;
            _context2.p = 1;
            _context2.n = 2;
            return pesquisa.enviaRespostas(payload, identificador);
          case 2:
            _yield$pesquisa$envia = _context2.v;
            data = _yield$pesquisa$envia.data;
            return _context2.a(2, data);
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            throw new Error(_t2);
          case 4:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 3]]);
    }))();
  }
};
var getters = {
  perguntas: function perguntas(state) {
    return state.perguntas;
  },
  pesquisa: function pesquisa(state) {
    return state.pesquisa;
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};